import { Link } from 'react-router-dom';
import './Footer.css';
import logo from './images/logo-white.svg';
import instagram from './images/instagram.svg';
import twitter from './images/twitter.svg';
import linkedin from './images/linkedin.svg';
import facebook from './images/facebook.svg';
import Contact from '../common/components/contact/Contact';
import { isStaging } from '../utils/Utils';
import React from 'react';

function Footer() {
  const instagramUrl = 'https://instagram.com/getsera.io';
  const twitterUrl = 'https://twitter.com/getsera_io';
  const linkedinUrl = 'https://www.linkedin.com/company/getsera/';
  const facebookUrl = 'https://www.facebook.com/getsera.io';

  const showContactForm = () => {
    return isStaging();
  }

  return (
    <section className='footer'>
      <div>
      <div className='container'>
        
        <div className='left'>
          <img src={logo} alt='LogoWhite' />
          
          <p>
          Take control of your personal finance with enabling technology and an actionable roadmap to achieve zero debt. <br/>Financial Freedom. Simplified.
          </p>
          
        </div>

        <div className='right'>
          <div>
            <p className='title'>Company</p>
            <p><Link to='/about-us' className='white link'>About us</Link></p>
            <p><Link to='/phong-nguyen-founders-story' className='white link'>Founder&apos;s story</Link></p>
            <p><Link to='/terms-and-conditions' className='white link'>Terms and conditions</Link></p>
            <p><Link to='/disclaimer' className='white link'>Disclaimer</Link></p>
            <p><Link to='/privacy-policy' className='white link'>Privacy Policy</Link></p>
          </div>
          <div>
            <p className='title'>Info</p>
            <p><a className='link' href='/financial-wellness-blog/'>Blog</a></p>
            <p><a className='link' href='/financial-wellness-blog/faq/'>FAQ</a></p>
            {(showContactForm()) ? (
                <React.Fragment>
                  <Contact />
                  <p><Link to='/investors' className='white link'>Investors</Link></p>
                </React.Fragment>
              ) : (
                <p><a className='link' href='mailto:info@getsera.io'>Contact</a></p>
              )
            }
          </div>
        </div>
      </div>
      <div className='disclaimer'>Disclaimer: This is for educational purposes. Your results may vary, restrictions apply.</div>
      <div className='bottom'>
        <div>© 2024 Sera | Financial Freedom. Simplified. All rights reserved, Era-X Corporation dba Sera.</div>
        <div className='social'>
          <div><a href={instagramUrl}><img src={instagram} alt='' /></a></div>
          <div><a href={twitterUrl}><img src={twitter} alt='' /></a></div>
          <div><a href={linkedinUrl}><img src={linkedin} alt='' /></a></div>
          <div><a href={facebookUrl}><img src={facebook} alt='' /></a></div>
        </div>
      </div>
      </div>

    </section>
  );
}

export default Footer;